import * as React from 'react'

import { cn } from '@/lib/utils'

/** Textarea — Input 과 같은 테두리·포커스 링. 여러 줄 입력(신고 본문 등). */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          'w-full min-w-0 rounded-lg border border-border-strong bg-surface px-3 py-2 text-sm text-text outline-none transition-colors',
          'placeholder:text-text-subtle',
          'focus:border-primary focus:ring-2 focus:ring-primary/20',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-surface-muted disabled:opacity-60',
          'aria-invalid:border-danger aria-invalid:ring-2 aria-invalid:ring-danger/20',
          'dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100',
          className,
        )}
        {...props}
      />
    )
  },
)

export { Textarea }
